import clsx from 'clsx';
import { SkeletonBlock } from './SkeletonBlock.tsx';

interface SkeletonTextProps {
  className?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
}

export function SkeletonText({ className, size = 'sm' }: SkeletonTextProps) {
  return (
    <div
      className={clsx(
        className,
        'flex items-center',
        size === 'xs' && 'h-4',
        size === 'sm' && 'h-5',
        size === 'md' && 'h-6',
        size === 'lg' && 'h-7'
      )}
    >
      <SkeletonBlock
        className={clsx(
          'w-full',
          size === 'xs' && 'h-1.5',
          size === 'sm' && 'h-2',
          size === 'md' && 'h-2',
          size === 'lg' && 'h-3'
        )}
      />
    </div>
  );
}
